import React, { useState } from 'react';
import { HubList } from './HubList';
import HubSlotDetail from './HubSlotDetail';
import { HubSwitchKey } from './Settings';

export default function HubAndSlots({ ...props }) {
    const [hubNShiftScreenSwitch, setHubNShiftScreenSwitch] = useState(
        HubSwitchKey.HUB_VIEW,
    );
    const [selectedHub, setSelectedHub] = useState(null);
    switch (hubNShiftScreenSwitch) {
        case HubSwitchKey.HUB_VIEW:
            return (
                <HubList
                    {...{
                        ...props,
                        hubNShiftScreenSwitch,
                        setHubNShiftScreenSwitch,
                        setSelectedHub,
                    }}
                />
            );
        case HubSwitchKey.HUB_DETAIL_VIEW:
            return (
                <HubSlotDetail
                    {...{
                        ...props,
                        hubNShiftScreenSwitch,
                        setHubNShiftScreenSwitch,
                        selectedHub,
                    }}
                />
            );
        default:
            return (
                <HubList
                    {...{
                        ...props,
                        hubNShiftScreenSwitch,
                        setHubNShiftScreenSwitch,
                    }}
                />
            );
    }
}
